import { render, staticRenderFns } from "./UsuarioFornecedorAprovadorAutorizadoForm.vue?vue&type=template&id=ecd0a200&scoped=true&lang=html"
import script from "./UsuarioFornecedorAprovadorAutorizadoForm.vue?vue&type=script&lang=js"
export * from "./UsuarioFornecedorAprovadorAutorizadoForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecd0a200",
  null
  
)

export default component.exports